import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import { connect } from 'react-redux'

// @material-ui/icons

// core components
import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import Parallax from "components/Parallax/Parallax.jsx";

import landingPageStyle from "assets/jss/material-kit-react/views/landingPage.jsx";

// Sections for this page
import ProductSection from "./Sections/ProductSection.jsx";

const dashboardRoutes = [];

class LandingPage extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      dataMenu: [],
      dataMedia: [],
      dataSlider: [],
      dataButtons: [],
      dataBlocks: [],
      dataCustom: [],
      isLoading: false
    }
  }

  componentWillMount() {
    this.setState({
      isLoading:true,
      dataMenu: this.props.data.menu,
      dataMedia: this.props.data.media,
      dataSlider: this.props.data.slider,
      dataButtons: this.props.data.buttons,
      dataBlocks: this.props.data.blocks,
      dataCustom: this.props.data.custom_fields
    });
  }

  componentDidMount(){
    this.setState({isLoading:false});
  }

  render() {
    const { data, classes, ...rest } = this.props;
    const { isLoading, dataMedia, dataMenu, dataSlider, dataButtons, dataCustom, dataBlocks } = this.state;
    const logo = dataMedia.filter( u => u.title === 'logo');
    const headerImg = dataMedia.filter( u => u.title === 'homepageHeader');
    const headerImgUrl = headerImg.map(res => res.url);
    const headerButton = dataButtons.filter( u => u.id === 1 );
    const headerButtonLink = headerButton.map(item => item.link);
    const headerButtonText = headerButton.map(item => item.text);

    // if (isLoading) {
    //   return <Loader />
    // }

    return (
      <div>
        <Header
          color="transparent"
          routes={dashboardRoutes}
          brand={ logo.length > 0 ? logo.map(res =>
            <span key={res.id}>
              <a href='/'>
                <img src={res.url} width="65" alt={res.title} />
              </a>
            </span>
          ) : "Auto Naxis"
          }
          rightLinks={<HeaderLinks data={dataMenu} />}
          fixed
          changeColorOnScroll={{
            height: 400,
            color: "white"
          }}
          {...rest}
        />
        <Parallax filter image={ headerImg ? headerImgUrl : require("assets/img/landing-bg.jpg") }>
          <div className={classes.container}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={8}>
                <h1 className={classes.title}>{ dataSlider.map(item => item.title) }</h1>
                <h4>{ dataSlider.map(item => item.description) }</h4>
                <br />
                <Button
                  color="#f7c612"
                  size="lg"
                  href={ headerButtonLink }
                  target="_self"
                  rel="noopener noreferrer"
                >
                  <i className="fas fa-link" />{ headerButtonText }
                </Button>
              </GridItem>
            </GridContainer>
          </div>
        </Parallax>
        <div className={classNames(classes.main, classes.mainRaised)}>
          <div className={classes.container}>
            <ProductSection data={dataBlocks} />
          </div>
        </div>
        <Footer
          dataCustom={dataCustom}
          dataMenu={dataMenu}
          >
        </Footer>
      </div>
    );
  }
}

function mapStateToProps(state){
  return { data: state.posts };
}

export default connect(mapStateToProps)(withStyles(landingPageStyle)(LandingPage))



// WEBPACK FOOTER //
// ./src/views/LandingPage/LandingPage.jsx